import Vue from 'vue'
// import Vuex from 'vuex'
import Http from 'vue-resource'

import { utils } from '@/libs/utils'
import axios from 'axios'
import debug from 'debug'
import { ENOTEMPTY } from 'constants';
var ajax_debug = debug("__esma:ajax")
Vue.use(Http);
var server_url = "/api"
var queue = require('fastq')(caching_worker, 1)

var cache = require("./cache").cache;
var from_cache_count = 0;

function caching_worker (arg, cb) {
  window.sessionStorage.setItem('last_event_time', (new Date()).getTime())
  if(typeof arg.data == "object"){
    arg.data.selectedCompany = Vue.localStorage.get("selectedCompany");
  }
  var cache_key = JSON.stringify({path:arg.path, data:arg.data});
  var cached  = cache.get(cache_key);
  // console.log("QUEUED: AJAX POST ON SUCCESS : CHECK CACHE", {cached,cache_key})
  if( cached != null){
    from_cache_count++
    // console.log("QUEUED: AJAX POST ON SUCCESS : FROM CACHE", {from_cache_count,cache_key, cached})
    if (cached.body.success == true) {
      return cb(null, cached.body.data);
    } else {
      return cb(cached.body.error, cached, cached.body.error_code || false);
    }
  }
  // It is possible to reuse postExtended, and just use the arg.data of body, but for now, will be as is.
  // console.log("QUEUED: Ajax post", arg.path, arg.data)

  Vue.http.post(server_url + arg.path, arg.data, {
    method: "POST",
  }).then(response => {
    // console.log("QUEUED: AJAX POST ON SUCCESS", response)
    cache.set(cache_key,{body:response.body})
    if (response.body.success == true) {
        return cb(null, response.body.data);
    } else {
      return cb(response.body.error, response, response.body.error_code || false);
    }
  }, (response) => {
    // console.log("QUEUED: AJAX POST ON ERROR", response)
    return cb("サーバーへのアクセス中にエラーが発生しました。", null);
  });
}

export default {
  serverUrl: server_url,
  get_version: ( cb) => {
    window.sessionStorage.setItem('last_event_time', (new Date()).getTime())
    Vue.http.get("/static/version.txt").then(response => {
      if (response.status == 200){
        console.log("VERSION", response.body)
        try {
          cb(response.body.split("\n")[0].split(":")[1].trim());  
        } catch (error) {
          cb("--");
        }
      }
  })
  },
  get: (path, cb) => {
    window.sessionStorage.setItem('last_event_time', (new Date()).getTime())
    Vue.http.get(server_url + path).then(response => {
      ajax_debug("AJAX GET ON SUCCESS", response)
      if (response.body.success == true) {
        return cb(null, response.body.data);
      } else {
        return cb(response.body.error, response);
      }
    }, response => {
      ajax_debug("AJAX GET ON ERROR", response)
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);

    });
  },
  post_cached_queued: (path, data, cb) => { 
    queue.push({path, data}, cb)
  },

  post_cached_ttl: (path, data,ttl, cb) => {
    window.sessionStorage.setItem('last_event_time', (new Date()).getTime())
    if(typeof data == "object"){
      data.selectedCompany = Vue.localStorage.get("selectedCompany");
    }
    var cache_key = JSON.stringify({path:path, data:data});
    var cached  = cache.get(cache_key);
    if( cached != null){
      from_cache_count++
      // console.log("QUEUED: AJAX POST ON SUCCESS : FROM CACHE", {from_cache_count,cache_key, cached})
      if (cached.body.success == true) {
        return cb(null, cached.body.data);
      } else {
        return cb(cached.body.error, cached, cached.body.error_code || false);
      }
    }

    Vue.http.post(server_url + path, data, {
      method: "POST",
    }).then(response => {
      ajax_debug("AJAX POST ON SUCCESS", response)
      if (response.body.success == true) {
        cache.set(cache_key,{body:response.body},ttl)
        return cb(null, response.body.data);
      } else {
        return cb(response.body.error, response, response.body.error_code || false);
      }
    }, response => {
      console.log("AJAX POST ON ERROR", response)
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);
    });
  },
  post: (path, data, cb) => {
    window.sessionStorage.setItem('last_event_time', (new Date()).getTime())
    if(typeof data == "object"){
      data.selectedCompany = Vue.localStorage.get("selectedCompany");
    }
    if(path.indexOf("/set/") > -1 || path.indexOf("delete") > -1 ){
      cache.clear();
    }
    // It is possible to reuse postExtended, and just use the data of body, but for now, will be as is.
    ajax_debug("Ajax post", path, data)

    Vue.http.post(server_url + path, data, {
      method: "POST",
    }).then(response => {
      ajax_debug("AJAX POST ON SUCCESS", response)
      if (response.body.success == true) {
        return cb(null, response.body.data);
      } else {
        return cb(response.body.error, response, response.body.error_code || false);
      }
    }, response => {
      console.log("AJAX POST ON ERROR", response)
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);
    });
  },
  postExtended: (path, data, cb) => {
    window.sessionStorage.setItem('last_event_time', (new Date()).getTime())
    if(typeof data == "object"){
      data.selectedCompany = Vue.localStorage.get("selectedCompany");
    }
    if(path.indexOf("/set/") > -1 || path.indexOf("delete") > -1 ){
      cache.clear();
    }
    ajax_debug("test ajax post", path, data)
    Vue.http.post(server_url + path, data, {
      method: "POST",
      // headers: {
      //   "X-SmaUser": "TEST" + getUser()
      // }
    }).then(response => {
      ajax_debug("AJAX POST ON SUCCESS", response)
      if (response.body.success == true) {
        return cb(null, response.body); // Note that here it is different
      } else {
        return cb(response.body.error, response); // Note that here it is different too
      }
    }, response => {
      console.log("AJAX POST ON ERROR", response)
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);
    });
  }
}



// WEBPACK FOOTER //
// ./src/libs/ajax.js